import { MINIMUM_FONT_SIZE } from 'styles/typography'
const themeStyles = colors => {
  const styles = {
    header: {
      flexBasis: 130,
      marginRight: 20,
      paddingLeft: 0
    },
    container: {
      padding: '10px 20px'
    },
    label: {
      fontWeight: 700,
      fontSize: MINIMUM_FONT_SIZE,
      color: colors.approxBlack,
      textWrap: 'wrap',
      textTransform: 'uppercase',
      marginBottom: 3
    },
    text: {
      fontSize: 14,
      color: colors.approxBlack
    },
    autoWidth: {
      flexBasis: 'auto'
    },
    spanText: {
      fontWeight: 400,
      color: colors.approxBlack
    }
  }
  return styles
}
export default themeStyles
